import { render } from "./WorldCupPage.vue?vue&type=template&id=3a5ad514&scoped=true&ts=true"
import script from "./WorldCupPage.vue?vue&type=script&lang=ts"
export * from "./WorldCupPage.vue?vue&type=script&lang=ts"

import "./WorldCupPage.vue?vue&type=style&index=0&id=3a5ad514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5ad514"]])

export default __exports__